import React from 'react';
import Slider from '@material-ui/core/Slider';
import { debounce } from 'lodash';
var BPMSlider = function (props) {
    var _a = React.useState([parseInt(props.sliderMin) || 0, parseInt(props.sliderMax) || 200]), value = _a[0], setValue = _a[1];
    var throttlePropsUpdate = React.useCallback(debounce(function (sliderMin, sliderMax) {
        if (props.onSliderChange) {
            props.onSliderChange(sliderMin, sliderMax);
        }
    }, 300), []);
    var handleChange = function (_event, _newValue) {
        var newValue = _newValue;
        setValue(newValue);
        throttlePropsUpdate(newValue[0], newValue[1]);
    };
    return (React.createElement("div", { className: "BPMSlider " + (props.onlySlider ? 'only-slider' : '') },
        props.captionOrientation === 'top' && React.createElement("span", { className: "slider-caption" }, props.caption),
        React.createElement("div", { className: "slider-container" },
            props.captionOrientation === 'left' && React.createElement("span", { className: "slider-caption left" }, props.caption),
            React.createElement("span", { className: "sliderMin" }, value[0]),
            React.createElement("div", { className: 'slider' },
                React.createElement(Slider, { value: value, onChange: handleChange, min: 0, max: 200, color: 'primary' })),
            React.createElement("span", { className: "sliderMax" }, value[1])),
        props.checkmarkText &&
            React.createElement("div", { className: "checkbox-text-container" },
                React.createElement("label", { className: "label" },
                    React.createElement("input", { id: "checkBox", type: "checkbox", checked: props.showHalfTime || false, onChange: function () {
                            if (props.onHalftimeChange) {
                                if (!props.showHalfTime)
                                    props.onHalftimeChange(true);
                                else
                                    props.onHalftimeChange(false);
                            }
                        } }),
                    React.createElement("label", { htmlFor: "checkBox", className: "text" }, props.checkmarkText)))));
};
export default BPMSlider;
//# sourceMappingURL=BPMSlider.js.map